import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  OnDestroy,
  Output
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'btn-dropdown',
  templateUrl: './btn-dropdown.component.html',
  styleUrls: ['./btn-dropdown.component.scss'],
  host: {
    '(document:click)': 'documentClicked($event)'
  }
})
export class BtnDropdownComponent implements OnInit, OnDestroy {
  @Input()
  listTitle: string;
  @Input()
  image: string;
  @Input()
  items: BtnDropdownItem<any>[] = [];
  @Input()
  parentId: number;
  @Input()
  isLoading: boolean = false;

  @Output()
  clickedItem = new EventEmitter<any>();

  @Output()
  clickedDropdown = new EventEmitter<any>();

  private eventsSubscription: Subscription;

  @Input()
  events?: Observable<any>;

  isOpen: boolean = false;
  label: string;

  ngOnInit() {
    // close if another dropdown is opened
    if (this.events) {
      this.eventsSubscription = this.events.subscribe(({ data }) => {
        if (this.parentId !== data.dropdownId) {
          this.isOpen = false;
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }

  documentClicked($event: any) {
    var path = $event.path || this.getPath($event);
    if (!!path && (path as any[]).some(obj => obj.localName == 'btn-dropdown')) return;

    this.isOpen = false;
  }

  toggleState($event: any) {
    this.isOpen = !this.isOpen;
    this.clickedDropdown.emit({ dropdownId: this.parentId, isOpen: this.isOpen });
  }

  itemClicked(item: BtnDropdownItem<any>) {
    this.clickedItem.emit({ item: item, parentId: this.parentId });
  }

  private getPath($event: any) {
    var path = [];
    var currentElem = $event.target;
    while (currentElem) {
      path.push(currentElem);
      currentElem = currentElem.parentElement;
    }
    if (path.indexOf(window) === -1 && path.indexOf(document) === -1) path.push(document);
    if (path.indexOf(window) === -1) path.push(window);
    return path;
  }
}

export class BtnDropdownItem<T> {
  constructor(id: number, label: string, url: string) {
    this.id = id;
    this.label = label;
    this.url = url;
  }

  id: number;
  label: string;
  url: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/btn-dropdown/btn-dropdown.component.ts